import FW from '../fw/fw';
import Env from '../fw/env';
import Logger from '../fw/logger';


export default class FccCaptions {

  #rmp;
  #resetFn = null;
  #fccDisplaySettingsFn = null;
  #fccFontColor = 'white';
  #fccFontOpacity = 1;
  #fccFontSize = 1;
  #fccFontFamily = 'arial';
  #fccFontEdge = 'none';
  #fccBackgroundColor = 'black';
  #fccBackgroundOpacity = 0.5;
  #fccWindowColor = 'black';
  #fccWindowOpacity = 0;
  #manualSelectionFontSizeFF = false;

  constructor(rmp) {
    this.#rmp = rmp;
  }

  static get options() {
    return {
      fontColor: ['white', 'black', 'red', 'green', 'blue', 'yellow', 'magenta', 'cyan'],
      fontOpacity: ['100%', '75%', '50%', '25%'],
      fontSize: ['300%', '200%', '175%', '150%', '125%', '100%', '75%', '50%'],
      fontFamily: ['arial', 'courier', 'georgia', 'impact', 'lucida console', 'tahoma', 'times new roman', 'trebuchet ms', 'verdana'],
      fontEdge: ['none', 'raised', 'depressed', 'outline', 'drop shadow'],
      backgroundColor: ['white', 'black', 'red', 'green', 'blue', 'yellow', 'magenta', 'cyan'],
      backgroundOpacity: ['100%', '75%', '50%', '25%', '0%'],
      windowColor: ['white', 'black', 'red', 'green', 'blue', 'yellow', 'magenta', 'cyan'],
      windowOpacity: ['100%', '75%', '50%', '25%', '0%']
    };
  }

  get fccFontColor() {
    return this.#fccFontColor;
  }

  get fccFontOpacity() {
    return this.#fccFontOpacity;
  }

  get fccFontSize() {
    return this.#fccFontSize;
  }

  get fccFontFamily() {
    return this.#fccFontFamily;
  }

  get fccFontEdge() {
    return this.#fccFontEdge;
  }

  get fccBackgroundColor() {
    return this.#fccBackgroundColor;
  }

  get fccBackgroundOpacity() {
    return this.#fccBackgroundOpacity;
  }

  get fccWindowColor() {
    return this.#fccWindowColor;
  }

  get fccWindowOpacity() {
    return this.#fccWindowOpacity;
  }

  static getColorWithOpacity(color, opacity) {
    let rgba;
    switch (color) {
      case 'white':
        rgba = 'rgba(255, 255, 255, ' + opacity + ')';
        break;
      case 'black':
        rgba = 'rgba(0, 0, 0, ' + opacity + ')';
        break;
      case 'red':
        rgba = 'rgba(255, 0, 0, ' + opacity + ')';
        break;
      case 'green':
        rgba = 'rgba(0, 128, 0, ' + opacity + ')';
        break;
      case 'blue':
        rgba = 'rgba(0, 0, 255, ' + opacity + ')';
        break;
      case 'yellow':
        rgba = 'rgba(255, 255, 0, ' + opacity + ')';
        break;
      case 'magenta':
        rgba = 'rgba(255, 0, 255, ' + opacity + ')';
        break;
      case 'cyan':
        rgba = 'rgba(0, 255, 255, ' + opacity + ')';
        break;
      default:
        rgba = 'rgba(255, 255, 255, 1)';
        break;
    }
    return rgba;
  }

  static updateSelectUI(id, newValue) {
    const select = document.getElementById(id);
    if (select) {
      select.value = newValue;
    }
  }

  #onSelectChange(fccOption, reset, initial, event) {
    FW.eventStopPrevent(event);
    Logger.print('captions', 'changing FCC setting: ' + fccOption);
    let prop;
    let css;
    const html5VideoCueStyle = !this.#rmp.hasExternalCCFiles || (this.#rmp.hasExternalCCFiles && Env.isIos[0]);
    switch (fccOption) {
      case 'fontColor':
        if (reset) {
          this.#fccFontColor = 'white';
          this.#fccFontOpacity = 1;
        } else if (initial) {
          this.#fccFontColor = this.#rmp.ccFontColor;
          this.#fccFontOpacity = this.#rmp.ccFontOpacity;
        } else {
          if (event && event.target && event.target.value) {
            this.#fccFontColor = event.target.value;
          } else {
            this.#fccFontColor = 'white';
          }
        }
        prop = '{color: ' + FccCaptions.getColorWithOpacity(this.#fccFontColor, this.#fccFontOpacity) + ' !important;}';
        if (html5VideoCueStyle) {
          css = 'video.rmp-video::cue ' + prop;
        } else {
          css = '.rmp-cc-cue ' + prop;
        }
        FccCaptions.updateSelectUI('rmp-fcc-font-color', this.#fccFontColor);
        if (reset || initial) {
          FccCaptions.updateSelectUI('rmp-fcc-font-opacity', (this.#fccFontOpacity * 100) + '%');
        }
        break;
      case 'fontOpacity':
        this.#fccFontOpacity = parseInt((event.target.value).slice(0, -1)) / 100;
        prop = '{color: ' + FccCaptions.getColorWithOpacity(this.#fccFontColor, this.#fccFontOpacity) + ' !important;}';
        if (html5VideoCueStyle) {
          css = 'video.rmp-video::cue ' + prop;
        } else {
          css = '.rmp-cc-cue ' + prop;
        }
        FccCaptions.updateSelectUI('rmp-fcc-font-opacity', (this.#fccFontOpacity * 100) + '%');
        break;
      case 'fontSize':
        if (reset) {
          this.#fccFontSize = 1;
        } else if (initial) {
          this.#fccFontSize = this.#rmp.ccFontSize;
        } else {
          if (event && event.target && event.target.value) {
            this.#fccFontSize = parseInt((event.target.value).slice(0, -1)) / 100;
          } else {
            if ((Env.isIpadOS || Env.isMacosSafari[0])) {
              if (this.#rmp.isInFullscreen) {
                this.#fccFontSize = 1.5;
              } else {
                this.#fccFontSize = 1;
              }
            }
          }
        }
        if (html5VideoCueStyle) {
          if (Env.isFirefox) {
            if (!this.#manualSelectionFontSizeFF) {
              prop = '{}';
              this.#manualSelectionFontSizeFF = true;
            } else if (reset) {
              prop = '{font-size: revert-layer}';
            } else {
              prop = '{font-size: ' + this.#fccFontSize * 100 + '%}';
            }
          } else {
            prop = '{font-size: ' + this.#fccFontSize * 100 + '%}';
          }
          css = 'video.rmp-video::cue' + prop;
        } else {
          prop = '{font-size: ' + this.#fccFontSize * 18 + 'px !important;}';
          css = '.rmp-cc-display ' + prop;
        }
        FccCaptions.updateSelectUI('rmp-fcc-font-size', (this.#fccFontSize * 100) + '%');
        break;
      case 'fontFamily':
        if (reset) {
          this.#fccFontFamily = 'Arial, Helvetica, sans-serif';
        } else if (initial) {
          this.#fccFontFamily = this.#rmp.ccFontFamily + ', Helvetica, sans-serif';
        } else {
          this.#fccFontFamily = event.target.value + ', Helvetica, sans-serif';
        }
        prop = '{font-family: ' + this.#fccFontFamily + ' !important;}';
        if (html5VideoCueStyle) {
          css = 'video.rmp-video::cue ' + prop;
        } else {
          css = '.rmp-cc-cue ' + prop;
        }
        FccCaptions.updateSelectUI('rmp-fcc-font-family', this.#fccFontFamily.toLowerCase().split(',')[0]);
        break;
      case 'fontEdge':
        if (reset) {
          this.#fccFontEdge = 'none';
        } else if (initial) {
          this.#fccFontEdge = this.#rmp.ccFontEdge;
        } else {
          this.#fccFontEdge = event.target.value;
        }
        switch (this.#fccFontEdge) {
          case 'none':
            prop = '{text-shadow: none !important;}';
            if (html5VideoCueStyle) {
              css = 'video.rmp-video::cue ' + prop;
            } else {
              css = '.rmp-cc-cue ' + prop;
            }
            break;
          case 'raised':
            prop = '{text-shadow: rgb(0, 0, 0) 0px 0px 5px, rgb(0, 0, 0) 0px 1px 5px, rgb(0, 0, 0) 0px 2px 5px !important;}';
            if (html5VideoCueStyle) {
              css = 'video.rmp-video::cue ' + prop;
            } else {
              css = '.rmp-cc-cue ' + prop;
            }
            break;
          case 'depressed':
            prop = '{text-shadow: rgb(0, 0, 0) 0px -2px 1px !important;}';
            if (html5VideoCueStyle) {
              css = 'video.rmp-video::cue ' + prop;
            } else {
              css = '.rmp-cc-cue ' + prop;
            }
            break;
          case 'outline':
            prop = '{text-shadow: rgb(0, 0, 0) -2px 0px 1px, rgb(0, 0, 0) 2px 0px 1px, rgb(0, 0, 0) 0px -2px 1px, rgb(0, 0, 0) 0px 2px 1px, rgb(0, 0, 0) -1px 1px 1px, rgb(0, 0, 0) 1px 1px 1px, rgb(0, 0, 0) 1px -1px 1px, rgb(0, 0, 0) 1px 1px 1px !important;}';
            if (html5VideoCueStyle) {
              css = 'video.rmp-video::cue ' + prop;
            } else {
              css = '.rmp-cc-cue ' + prop;
            }
            break;
          case 'drop shadow':
            prop = '{text-shadow: rgb(0, 0, 0) 0px 2px 1px !important;}';
            if (html5VideoCueStyle) {
              css = 'video.rmp-video::cue ' + prop;
            } else {
              css = '.rmp-cc-cue ' + prop;
            }
            break;
          default:
            prop = '{text-shadow: none !important;}';
            if (html5VideoCueStyle) {
              css = 'video.rmp-video::cue ' + prop;
            } else {
              css = '.rmp-cc-cue ' + prop;
            }
            break;
        }
        FccCaptions.updateSelectUI('rmp-fcc-font-edge', this.#fccFontEdge);
        break;
      case 'backgroundColor':
        if (reset) {
          this.#fccBackgroundColor = 'black';
          this.#fccBackgroundOpacity = 0.5;
        } else if (initial) {
          this.#fccBackgroundColor = this.#rmp.ccBackgroundColor;
          this.#fccBackgroundOpacity = this.#rmp.ccBackgroundOpacity;
        } else {
          this.#fccBackgroundColor = event.target.value;
        }
        prop = '{background-color: ' + FccCaptions.getColorWithOpacity(this.#fccBackgroundColor,
          this.#fccBackgroundOpacity) + ' !important;}';
        if (html5VideoCueStyle) {
          if (Env.isApple) {
            css = 'video::-webkit-media-text-track-display-backdrop ' + prop;
          } else {
            css = 'video.rmp-video::cue ' + prop;
          }
        } else {
          css = '.rmp-cc-cue ' + prop;
        }
        FccCaptions.updateSelectUI('rmp-fcc-background-color', this.#fccBackgroundColor);
        if (reset || initial) {
          FccCaptions.updateSelectUI('rmp-fcc-background-opacity', (this.#fccBackgroundOpacity * 100) + '%');
        }
        break;
      case 'backgroundOpacity':
        this.#fccBackgroundOpacity = parseInt((event.target.value).slice(0, -1)) / 100;
        prop = '{background-color: ' + FccCaptions.getColorWithOpacity(this.#fccBackgroundColor,
          this.#fccBackgroundOpacity) + ' !important;}';
        if (html5VideoCueStyle) {
          if (Env.isApple) {
            css = 'video::-webkit-media-text-track-display-backdrop ' + prop;
          } else {
            css = 'video.rmp-video::cue ' + prop;
          }
        } else {
          css = '.rmp-cc-cue ' + prop;
        }
        FccCaptions.updateSelectUI('rmp-fcc-background-opacity', (this.#fccBackgroundOpacity * 100) + '%');
        break;
      case 'windowColor':
        if (reset) {
          this.#fccWindowColor = 'black';
          this.#fccWindowOpacity = 0;
        } else if (initial) {
          this.#fccWindowColor = this.#rmp.ccWindowColor;
          this.#fccWindowOpacity = this.#rmp.ccWindowOpacity;
        } else {
          this.#fccWindowColor = event.target.value;
        }
        prop = '{background-color: ' + FccCaptions.getColorWithOpacity(this.#fccWindowColor,
          this.#fccWindowOpacity) + ' !important;}';
        if (html5VideoCueStyle) {
          css = 'video.rmp-video::-webkit-media-text-track-display ' + prop;
        } else {
          css = '.rmp-cc-display ' + prop;
        }
        FccCaptions.updateSelectUI('rmp-fcc-window-color', this.#fccWindowColor);
        if (reset || initial) {
          FccCaptions.updateSelectUI('rmp-fcc-window-opacity', (this.#fccWindowOpacity * 100) + '%');
        }
        break;
      case 'windowOpacity':
        this.#fccWindowOpacity = parseInt((event.target.value).slice(0, -1)) / 100;
        prop = '{background-color: ' + FccCaptions.getColorWithOpacity(this.#fccWindowColor,
          this.#fccWindowOpacity) + ' !important;}';
        if (html5VideoCueStyle) {
          css = 'video.rmp-video::-webkit-media-text-track-display ' + prop;
        } else {
          css = '.rmp-cc-display ' + prop;
        }
        FccCaptions.updateSelectUI('rmp-fcc-window-opacity', (this.#fccWindowOpacity * 100) + '%');
        break;
      default:
        break;
    }
    if (css) {
      Logger.print('captions', 'appending custom CSS: ' + css);
      FW.appendStyle(css, this.#rmp.shadowRoot);
    }
  }

  #setCaptionsStyle(reset, initial) {
    this.#onSelectChange('fontColor', reset, initial, null);
    this.#onSelectChange('fontSize', reset, initial, null);
    this.#onSelectChange('fontFamily', reset, initial, null);
    this.#onSelectChange('fontEdge', reset, initial, null);
    this.#onSelectChange('backgroundColor', reset, initial, null);
    this.#onSelectChange('windowColor', reset, initial, null);
  }

  #resetFcc(event) {
    FW.eventStopPrevent(event);
    Logger.print('captions', 'reset FCC settings');
    // reset Google Cast FCC settings
    if (this.#rmp.rmpGoogleCastText) {
      this.#rmp.rmpGoogleCastText.resetSettings();
    }
    // reset player FCC settings
    this.#setCaptionsStyle(true, false);
  }

  #filterInputSettings() {
    const keys = Object.keys(FccCaptions.options);
    keys.forEach(key => {
      switch (key) {
        case 'fontColor':
          if (!FccCaptions.options[key].includes(this.#rmp.ccFontColor)) {
            this.#rmp.ccFontColor = 'white';
          }
          break;
        case 'fontOpacity':
          if (!FccCaptions.options[key].includes((this.#rmp.ccFontOpacity * 100) + '%')) {
            this.#rmp.ccFontOpacity = 1;
          }
          break;
        case 'fontSize':
          if (!FccCaptions.options[key].includes((this.#rmp.ccFontSize * 100) + '%')) {
            this.#rmp.ccFontSize = 1;
          }
          break;
        case 'fontFamily':
          if (!FccCaptions.options[key].includes(this.#rmp.ccFontFamily)) {
            this.#rmp.ccFontFamily = 'arial';
          }
          break;
        case 'fontEdge':
          if (!FccCaptions.options[key].includes(this.#rmp.ccFontEdge)) {
            this.#rmp.ccFontEdge = 'none';
          }
          break;
        case 'backgroundColor':
          if (!FccCaptions.options[key].includes(this.#rmp.ccBackgroundColor)) {
            this.#rmp.ccBackgroundColor = 'black';
          }
          break;
        case 'backgroundOpacity':
          if (!FccCaptions.options[key].includes((this.#rmp.ccBackgroundOpacity * 100) + '%')) {
            this.#rmp.ccBackgroundOpacity = 0.5;
          }
          break;
        case 'windowColor':
          if (!FccCaptions.options[key].includes(this.#rmp.ccWindowColor * 100)) {
            this.#rmp.ccWindowColor = 'black';
          }
          break;
        case 'windowOpacity':
          if (!FccCaptions.options[key].includes((this.#rmp.ccWindowOpacity * 100) + '%')) {
            this.#rmp.ccWindowOpacity = 0;
          }
          break;
        default:
          break;
      }
    });
    Logger.print('captions', 'filtered input settings');
    Logger.print('captions', 'ccFontColor: ' + this.#rmp.ccFontColor + ' - ccFontOpacity: ' + this.#rmp.ccFontOpacity +
      ' - ccFontSize: ' + this.#rmp.ccFontSize + ' - ccFontFamily: ' + this.#rmp.ccFontFamily +
      ' - ccFontEdge: ' + this.#rmp.ccFontEdge + ' - ccBackgroundColor: ' + this.#rmp.ccBackgroundColor +
      ' - ccBackgroundOpacity: ' + this.#rmp.ccBackgroundOpacity + ' - ccWindowColor: ' + this.#rmp.ccWindowColor +
      ' - ccWindowOpacity: ' + this.#rmp.ccWindowOpacity);
  }

  displaySettings(event) {
    FW.eventStopPrevent(event);
    if (this.#rmp.dom.captionsOverlayFCCSettingsArea.style.display === 'none') {
      FW.hide(this.#rmp.dom.captionsOverlayLevelsArea);
      FW.showFlex(this.#rmp.dom.captionsOverlayFCCSettingsArea);
    } else {
      FW.showFlex(this.#rmp.dom.captionsOverlayLevelsArea);
      FW.hide(this.#rmp.dom.captionsOverlayFCCSettingsArea);
    }
  }

  init() {
    this.#filterInputSettings();
    Logger.print('captions', 'adding FCC settings menu');
    const labels = this.#rmp.labels;
    const rtl = this.#rmp.rtl;
    this.#rmp.dom.fccCompliantSettings = FW.createElement(
      'button',
      'rmp-button rmp-module-fcc-settings',
      labels.hint.settings,
      rtl
    );
    this.#fccDisplaySettingsFn = this.displaySettings.bind(this);
    FW.addEvents(['touchend', 'click'], this.#rmp.dom.fccCompliantSettings, this.#fccDisplaySettingsFn);
    this.#rmp.dom.captionsOverlayLevelsArea.appendChild(this.#rmp.dom.fccCompliantSettings);
    // new overlay for FCC settings
    this.#rmp.dom.captionsOverlayFCCSettingsArea = FW.createElement('div', 'rmp-overlay-levels-area rmp-overlay-fcc-settings-area');
    FW.hide(this.#rmp.dom.captionsOverlayFCCSettingsArea);
    this.#rmp.dom.captionsOverlayWrapper.appendChild(this.#rmp.dom.captionsOverlayFCCSettingsArea);
    this.#rmp.rmpAccessible.button(this.#rmp.dom.fccCompliantSettings, labels.hint.settings, true);
    // go back button
    const _goBackButton = FW.createElement(
      'button',
      'rmp-button rmp-module-fcc-settings',
      labels.hint.back,
      rtl
    );
    FW.addEvents(['touchend', 'click'], _goBackButton, this.#fccDisplaySettingsFn);
    this.#rmp.dom.captionsOverlayFCCSettingsArea.appendChild(_goBackButton);
    this.#rmp.rmpAccessible.button(_goBackButton, labels.hint.back, true);
    const keys = Object.keys(labels.fccCaptions);
    const keyToID = {
      fontColor: 'rmp-fcc-font-color',
      fontOpacity: 'rmp-fcc-font-opacity',
      fontSize: 'rmp-fcc-font-size',
      fontFamily: 'rmp-fcc-font-family',
      fontEdge: 'rmp-fcc-font-edge',
      backgroundColor: 'rmp-fcc-background-color',
      backgroundOpacity: 'rmp-fcc-background-opacity',
      windowColor: 'rmp-fcc-window-color',
      windowOpacity: 'rmp-fcc-window-opacity'
    };
    keys.forEach(key => {
      const fccText = labels.fccCaptions[key];
      const fccLabel = FW.createElement('label', 'rmp-label', fccText);
      const id = keyToID[key];
      fccLabel.setAttribute('for', id);
      const fccSelect = FW.createElement('select', 'rmp-select');
      fccSelect.setAttribute('id', id);
      fccSelect.setAttribute('name', id);
      for (let i = 0, len = FccCaptions.options[key].length; i < len; i++) {
        const optionValue = FccCaptions.options[key][i];
        const optionElement = FW.createElement('option', 'rmp-option', optionValue);
        optionElement.setAttribute('value', optionValue);
        fccSelect.appendChild(optionElement);
      }
      fccSelect.addEventListener('change', this.#onSelectChange.bind(this, key, false, false));
      if (Env.isIpadOS || Env.isMacosSafari[0]) {
        this.#rmp.on('enterfullscreen', () => {
          this.#onSelectChange('fontSize', false, false, null);
        });
        this.#rmp.on('exitfullscreen', () => {
          this.#onSelectChange('fontSize', false, false, null);
        });
      }
      this.#rmp.dom.captionsOverlayFCCSettingsArea.appendChild(fccLabel);
      this.#rmp.dom.captionsOverlayFCCSettingsArea.appendChild(fccSelect);
    });
    // set initial player FCC settings
    this.#setCaptionsStyle(false, true);
    // default 
    const _defaultFccSettingsButton = FW.createElement(
      'button',
      'rmp-button rmp-module-fcc-settings rmp-module-fcc-settings-default',
      labels.hint.default,
      rtl
    );
    this.#resetFn = this.#resetFcc.bind(this);
    FW.addEvents(['touchend', 'click'], _defaultFccSettingsButton, this.#resetFn);
    this.#rmp.dom.captionsOverlayFCCSettingsArea.appendChild(_defaultFccSettingsButton);
    this.#rmp.rmpAccessible.button(_defaultFccSettingsButton, labels.hint.default, true);
  }

}
